export default __webpack_public_path__ + "static/media/gold_logo.5d769148.png";